import $ from 'jquery'
import Page from "./components/LicensesPage"

export default function init() {
    new Page().init($('.licensesPage'))
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/index.js